module.exports = __webpack_public_path__ + "img/20200304152645031.17b3b906.jpg";